// Versão do app (SemVer: MAJOR.MINOR.PATCH). Fonte única — exibida no rodapé.
// Suba a cada alteração: PATCH=correção, MINOR=nova feature, MAJOR=mudança incompatível.
export const APP_VERSION = '1.1.1';
